<mat-drawer-container   [hasBackdrop] = "backdrop" 
                        redirectLogin>

  <mat-drawer #drawer 
              [mode]  = "drawerMode" 
              class   = "pl-bgc">

    <main-menu  #mainMenu
                (clicked)   = "drawer.close()"
                [menuConf]  = "menuConf"></main-menu>

  </mat-drawer>

  <mat-drawer-content>

    <main-header  #mainHeader 
                  [drawer]    = "drawer" 
                  [menuConf]  = "menuConf"></main-header>

    <div class="mx-3 mt-3">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>